import type { FunctionComponent } from 'react';
import { Button, Modal, showErrorToast, showSuccessToast } from '@fff-web/fff-ui-shared';
import { postCancelCredit } from '../../services/growth';
import breakpoints from '../../utils/breakpoints';
import { CUSTOM_CARE_URL } from '../../utils/redirectLinks';
import useCurrentWidth from '../commons/use-current-width/useCurrentWidth';
import boxImageDesktop from '../../assets/images/cancel-subscription/closed-box-desktop.jpg';
import boxImageMobile from '../../assets/images/cancel-subscription/closed-box-mobile.jpg';
import * as styles from './CreditModal.module.css';

interface CreditModalProps {
  isOpen: boolean;
  closeModal: () => void;
}

const CreditModal: FunctionComponent<CreditModalProps> = ({ isOpen, closeModal }) => {
  const currentWidth = useCurrentWidth();
  const isMobile = currentWidth <= breakpoints.medium;
  const boxImage = isMobile ? boxImageMobile : boxImageDesktop;

  const handleClickAccept = () => {
    closeModal();
    postCancelCredit()
      .then(() => {
        // display confirmation toast for 5 seconds and redirect user to the Homepage
        showSuccessToast(
          'Credit Granted',
          "You're all set. $25 Add-Ons Sale Credit will be added to the next eligible Add-Ons Sale!",
        );
        setTimeout(() => {
          window.location.assign('/');
        }, 5000);
      })
      .catch(() => {
        showErrorToast(
          'Credit Unsuccessful',
          `Your request could not be processed. 
          Please <a href="${CUSTOM_CARE_URL}">contact Customer Care</a> for more information.`,
        );
      });
  };

  return (
    <>
      <Modal isOpen={isOpen} className={styles.modal}>
        <img src={boxImage} alt="Box" />
        <div className={styles.content}>
          <h1>Wait, You’re Leaving $25 Behind</h1>
          <h3>
            $25 Add-Ons Credit for the next eligible Add-Ons sale!
            <sup>1</sup>
          </h3>
          <p>
            Stay for another bill date and get $25 Add-Ons Credit. You’ll be able to shop up to 70%
            OFF your favorite products!
          </p>
          <Button onClick={handleClickAccept}>ACCEPT GIFT</Button>
          <button type="button" className={styles.declineButton} onClick={closeModal}>
            Decline Gift
          </button>
          <p className={styles.disclaimer}>
            <sup>1</sup>
            Add-Ons Credit has no cash value and will expire if not used by the last date of next
            season’s Add-Ons sale. If your Add-Ons window has closed for the current season, the
            next eligible Add-Ons sale will be next season.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default CreditModal;
